import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const FIND_STATE_RESPONSIBLE_LIST_REQUEST = NS + 'FIND_STATE_RESPONSIBLE_LIST_REQUEST'
export const FIND_STATE_RESPONSIBLE_LIST_SUCCESS = NS + 'FIND_STATE_RESPONSIBLE_LIST_SUCCESS'
export const FIND_STATE_RESPONSIBLE_LIST_ERROR = NS + 'FIND_STATE_RESPONSIBLE_LIST_ERROR'

export const CHANGE_STATE_RESPONSIBLE = NS + 'CHANGE_STATE_RESPONSIBLE'

export const SAVE_STATE_RESPONSIBLE_REQUEST = NS + 'SAVE_STATE_RESPONSIBLE_REQUEST'
export const SAVE_STATE_RESPONSIBLE_SUCCESS = NS + 'SAVE_STATE_RESPONSIBLE_SUCCESS'
export const SAVE_STATE_RESPONSIBLE_ERROR = NS + 'SAVE_STATE_RESPONSIBLE_ERROR'




// WEBPACK FOOTER //
// ./src/modules/process/state/state-responsible/type.js